!(function (t) {
  var e = {};
  function i(s) {
    if (e[s]) return e[s].exports;
    var o = (e[s] = { i: s, l: !1, exports: {} });
    return t[s].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
  }
  (i.m = t),
    (i.c = e),
    (i.d = function (t, e, s) {
      i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: s });
    }),
    (i.r = function (t) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (i.t = function (t, e) {
      if ((1 & e && (t = i(t)), 8 & e)) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var s = Object.create(null);
      if (
        (i.r(s),
        Object.defineProperty(s, "default", { enumerable: !0, value: t }),
        2 & e && "string" != typeof t)
      )
        for (var o in t)
          i.d(
            s,
            o,
            function (e) {
              return t[e];
            }.bind(null, o)
          );
      return s;
    }),
    (i.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return i.d(e, "a", e), e;
    }),
    (i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (i.p = "/"),
    i((i.s = 3));
})({
  3: function (t, e, i) {
    t.exports = i("kI2Z");
  },
  kI2Z: function (t, e) {
    function i(t, e) {
      return (
        (function (t) {
          if (Array.isArray(t)) return t;
        })(t) ||
        (function (t, e) {
          if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t)))
            return;
          var i = [],
            s = !0,
            o = !1,
            l = void 0;
          try {
            for (
              var n, a = t[Symbol.iterator]();
              !(s = (n = a.next()).done) &&
              (i.push(n.value), !e || i.length !== e);
              s = !0
            );
          } catch (t) {
            (o = !0), (l = t);
          } finally {
            try {
              s || null == a.return || a.return();
            } finally {
              if (o) throw l;
            }
          }
          return i;
        })(t, e) ||
        (function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return s(t, e);
          var i = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === i && t.constructor && (i = t.constructor.name);
          if ("Map" === i || "Set" === i) return Array.from(t);
          if (
            "Arguments" === i ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
          )
            return s(t, e);
        })(t, e) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function s(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];
      return s;
    }
    function o(t, e) {
      var i = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(t);
        e &&
          (s = s.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          i.push.apply(i, s);
      }
      return i;
    }
    function l(t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? o(Object(i), !0).forEach(function (e) {
              n(t, e, i[e]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i))
          : o(Object(i)).forEach(function (e) {
              Object.defineProperty(
                t,
                e,
                Object.getOwnPropertyDescriptor(i, e)
              );
            });
      }
      return t;
    }
    function n(t, e, i) {
      return (
        e in t
          ? Object.defineProperty(t, e, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[e] = i),
        t
      );
    }
    var a = {
      init: function () {
        (wlCustomerID = window.hulkappsWishlist.customerID),
          (hulkShopDomain = window.hulkappsWishlist.domain),
          (wlCustomerStatus = wlCustomerID ? "Customer" : "Guest"),
          (wlBaseUrl = window.hulkappsWishlist.baseURL),
          (wlHulkUserUUID =
            window.HulkappWishlist._getCookie("hulk_wishlist_UserUUID") ||
            null);
        var t = document.querySelectorAll("[data-gridhulklist]");
        t &&
          t.forEach(function (t) {
            t.remove();
          });
        var e = document.getElementById("product-data");
        (collectionWishlistBtn = JSON.parse(e.textContent)),
          (iconOnImage =
            "true" === collectionWishlistBtn.custom_wishlist_icon
              ? "true"
              : "false"),
          (dataLayout =
            "false" === iconOnImage
              ? "beside_count"
              : collectionWishlistBtn.collection_count_layout),
          (hulkWlPopup = document.querySelector(
            "[data-hulkappsWishlistPopup]"
          )),
          (wlProductsData = []);
        var i = Shopify.locale,
          s = window.hulkappsWishlist.languageSettings,
          o = Object.keys(s).find(function (t) {
            return !0 === s[t].primary_language;
          }),
          l = s[i] ? s[i] : s[o],
          n = [];
        if (
          ((n.style = window.hulkappsWishlist.buttonStyleSettings),
          (n.general = window.hulkappsWishlist.generalSettings),
          (n.language = void 0 !== l ? l : s),
          (WishlistSettings = Object.assign({}, n)),
          (is_latest_notification =
            void 0 !== WishlistSettings.language.latest_notification_box &&
            WishlistSettings.language.latest_notification_box),
          "true" === collectionWishlistBtn.is_added_selector)
        ) {
          var r = ".af-productCard-image";
          document.querySelectorAll(r).forEach(function (t) {
            var e = t.querySelector('a[href*="/products/"]');
            if (e) {
              var i = e.getAttribute("href").split("/products/")[1];
              a._addWishlistBtn(null, t, i);
            }
          });
        } else {
          document.querySelectorAll(".card__information").forEach(function (t) {
            var e = t.querySelector(
              '.card__heading a[id^="CardLink-template--"], a[id^="CardLink--"]'
            );
            if (e) {
              var i = e.id.split("-"),
                s = i.length > 1 ? i[i.length - 1] : null;
              s && a._addWishlistBtn(s, e);
            }
          });
        }
        a._handleWishlistProductDetails(),
          (wishlistBtns = Array.from(
            document.querySelectorAll("[data-gridwlhulklist]")
          )),
          a._collectionProductStatus();
      },
      _addWishlistBtn: function (t, e) {
        var s =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : null,
          o = collectionWishlistBtn,
          n = o.collection_icon_background_type,
          a = o.custom_wishlist_icon_right,
          r = o.empty_set_custom_icon,
          u = o.collection_icon_size,
          c = o.collection_icon_type,
          d =
            "icon_round_background" === n
              ? "round"
              : "icon_square_background" === n
              ? "square"
              : "none",
          h = l(
            l(
              {
                href: "javascript:void(0)",
                "data-added": !1,
                "data-gridwlhulklist": "",
                "data-position": "true" == a ? "right" : "left",
              },
              "true" === iconOnImage && {
                "data-custom-wishlist-icon": iconOnImage,
              }
            ),
            t ? { "data-proID": t } : { "data-proHandle": s }
          ),
          p = document.createElement("a");
        p.classList.add(
          "icon-wishlist-heart-empty",
          "wishlist-btn",
          "grid-wishlist-btn",
          "heart-wishlist-animation"
        ),
          Object.entries(h).forEach(function (t) {
            var e = i(t, 2),
              s = e[0],
              o = e[1];
            return p.setAttribute(s, o);
          });
        var _ =
            "custom_icon" === WishlistSettings.style.button_icon_type
              ? '<img src="'.concat(
                  r,
                  '" class="hulkapps-wl-custom-icon" width="18px" height="18px" alt="wl custom icon">'
                )
              : '<i class="heart-hulk-animation hulkapps-wl-collection-icon" data-icon="'
                  .concat(c, '" data-icon-background="')
                  .concat(d, '"><i class="icon-wishlist-heart-empty"></i></i>'),
          m =
            "show" === WishlistSettings.general.collection_wishlist_count
              ? '<span></span><span class="count hulkapps-wl-collection-count" data-layout="'.concat(
                  dataLayout,
                  '">0</span>'
                )
              : "";
        (p.innerHTML =
          '<div style="display: initial;">\n                                '
            .concat(_, "\n                                ")
            .concat(m, "\n                              </div></a>")),
          e.insertAdjacentElement("afterend", p);
        var f = p.querySelector(".hulkapps-wl-collection-count");
        f &&
          "top_count" === dataLayout &&
          u > 20 &&
          ((f.style.right = "-0.3rem"),
          (f.style.bottom = "1.5rem"),
          (f.style.width = "1.8em"),
          (f.style.height = "1.8em"));
      },
      _handleWishlistProductDetails: function () {
        document.addEventListener("click", function (t) {
          // if (t.target.closest("[data-gridwlhulklist]")) {
          //     var e = t.target.closest("a"),
          //         i = e.getAttribute("data-proID"),
          //         s = e.getAttribute("data-proHandle");
          //     if ("Guest" !== wlCustomerStatus || WishlistSettings.general.is_guest_enabled)
          //         if ("Guest" !== wlCustomerStatus && WishlistSettings.general.has_multiple_wishlist) {
          //             searchWishlist = "";
          //             var o = document.querySelector("[data-wishlistsearch]");
          //             (o.value = ""), o.setAttribute("data-hulkcollection", i), a._updateWishlistSelection(i), (collectionWlBtnTarget = e), hulkWlPopup.classList.add("open");
          //             var l = hulkWlPopup.querySelector(".wishlist-modal__footer button");
          //             l.removeAttribute("data-addtowishlist"), l.setAttribute("data-addproducttowishlist", ""), document.body.classList.add("popup__active");
          //         } else {
          //             var n = "Customer" === wlCustomerStatus ? DefaultWishlistID : "";
          //             a._manageWishlistProducts(e, i, n, s);
          //         }
          //     else {
          //         var r = WishlistSettings.language.success_message.for_guest_login_disabled;
          //         HulkappWishlist._messageUpdate(r);
          //     }
          // }
          // if (t.target && t.target.hasAttribute("data-addproducttowishlist")) {
          //     var u,
          //         c = Array.from(document.querySelectorAll("[data-wishlistitem]"))
          //             .filter(function (t) {
          //                 return t.checked;
          //             })
          //             .map(function (t) {
          //                 return t.value;
          //             }),
          //         d = collectionWlBtnTarget.getAttribute("data-proID");
          //     null == d && (u = collectionWlBtnTarget.getAttribute("data-proHandle")), a._manageWishlistProducts(collectionWlBtnTarget, d, c, u);
          // }
        }),
          document.addEventListener("change", function (t) {
            var e = t.target,
              i = document.querySelector("[data-addproducttowishlist]");
            e && e.hasAttribute("data-wishlistitem") && i && (i.disabled = !1);
          });
      },
      _updateWishlistSelection: function (t) {
        var e = wlProductsData.filter(function (e) {
          return e.product_id == t;
        });
        document.querySelectorAll("[data-wishlistitem]").forEach(function (t) {
          return (t.checked = !1);
        }),
          e.forEach(function (t) {
            t.wishlist_ids.forEach(function (t) {
              var e = document.querySelector(
                '[data-wishlistitem][value="'.concat(t, '"]')
              );
              e && (e.checked = !0);
            });
          });
      },
      _manageWishlistProducts: function (t, e, i) {
        var s =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : null,
          o = t ? t.getAttribute("data-added") : null,
          l =
            "true" === o
              ? WishlistSettings.general.has_multiple_wishlist && i.length > 0
                ? "add"
                : "remove"
              : "add";
        "remove" === l
          ? a._removeProductFromWishlist(e, i)
          : a._addProductToWishlist(t, e, i, s);
      },
      _removeProductFromWishlist: function (t, e) {
        var i = l(
            { shop: hulkShopDomain, product_id: t, type: "web" },
            "Guest" === wlCustomerStatus
              ? { uuid: wlHulkUserUUID }
              : { customer_id: wlCustomerID, wishlist_ids: e }
          ),
          s =
            wlBaseUrl +
            ("Guest" === wlCustomerStatus
              ? "/wishlist/collection_product/delete/guest"
              : "/wishlist/collection_product/delete"),
          o = "Guest" !== wlCustomerStatus ? hulkShopDomain : null,
          n = "Guest" !== wlCustomerStatus ? wlCustomerID : null;
        HulkappWishlist._XMLHttpRequest("POST", s, i, o, n, function (t, e) {
          JSON.parse(e);
          if (200 === t) {
            var i =
              void 0 !==
              WishlistSettings.language.success_message.for_item_removed
                ? WishlistSettings.language.success_message.for_item_removed
                : "Product has been successfully removed from your wishlist.";
            HulkappWishlist._messageUpdate(i),
              a._collectionProductStatus(),
              hulkWlPopup.classList.remove("open");
          }
        });
      },
      _addProductToWishlist: function (t, e, i, s) {
        var o = l(
            l(
              { shop: hulkShopDomain },
              e && "null" !== e ? { product_id: e } : { product_handle: s }
            ),
            "Guest" === wlCustomerStatus
              ? { uuid: wlHulkUserUUID }
              : { customer_id: wlCustomerID, wishlist_ids: i }
          ),
          n =
            wlBaseUrl +
            ("Guest" === wlCustomerStatus
              ? "/wishlist/collection_product/add/guest"
              : "/wishlist/collection_product/add"),
          r = "Guest" !== wlCustomerStatus ? hulkShopDomain : null,
          u = "Guest" !== wlCustomerStatus ? wlCustomerID : null;
        HulkappWishlist._XMLHttpRequest("POST", n, o, r, u, function (e, i) {
          var s = JSON.parse(i);
          if (200 === e) {
            !wlHulkUserUUID &&
              s.data &&
              s.data.uuid &&
              a._setCookie("hulk_wishlist_UserUUID", s.data.uuid, 15),
              (t.dataset.proid = s.data.product_id);
            var o = function (t, e) {
              return void 0 !== WishlistSettings.language.success_message[t]
                ? WishlistSettings.language.success_message[t]
                : e;
            };
            a._collectionProductStatus(),
              is_latest_notification
                ? ((msg = o(
                    "for_login_users_latest",
                    "Product successfully updated in wishlist!"
                  )),
                  s.is_more_wishlist > 0 &&
                    (msg = o(
                      "for_update_login_users_latest",
                      "Product has been successfully updated in your wishlist, view <a href=".concat(
                        proxyPath,
                        ">My Wishlist</a>."
                      )
                    )))
                : "Guest" === customerStatus
                ? ((msg = o(
                    "without_login",
                    "Product successfully updated in wishlist!"
                  )),
                  is_latest_notification &&
                    (msg = o(
                      "without_login_latest",
                      "Product has been successfully updated in your wishlist, view <a href=".concat(
                        proxyPath,
                        ">My Wishlist</a>."
                      )
                    )))
                : ((msg = o(
                    "for_login_users",
                    "Product successfully updated in wishlist!"
                  )),
                  s.is_more_wishlist > 0 &&
                    (msg = o(
                      "for_update_login_users",
                      "Product has been successfully updated in your wishlist, view <a href=".concat(
                        proxyPath,
                        ">My Wishlist</a>."
                      )
                    ))),
              HulkappWishlist._messageUpdate(
                msg,
                s.data.title,
                s.data.image,
                WishlistSettings.language.latest_notification_box
              ),
              hulkWlPopup.classList.remove("open");
          }
        });
      },
      _setCookie: function (t, e, i) {
        var s = new Date();
        s.setTime(s.getTime() + 24 * i * 60 * 60 * 1e3);
        var o = "expires=" + s.toUTCString();
        (document.cookie = t + "=" + e + ";" + o + ";path=/"),
          "hulk_wishlist_UserUUID" == t && (wlHulkUserUUID = e);
      },
      _collectionProductStatus: function () {
        if (!wishlistBtns || 0 === wishlistBtns.length) return !1;
        var t = wishlistBtns
            .map(function (t) {
              return t.getAttribute("data-proID");
            })
            .filter(function (t) {
              return t;
            }),
          e = wishlistBtns
            .map(function (t) {
              return t.getAttribute("data-proHandle");
            })
            .filter(function (t) {
              return t;
            }),
          i = l(
            l(
              l(
                { shop: hulkShopDomain },
                t.length > 0 && {
                  ids: t.map(function (t) {
                    return { product_id: t };
                  }),
                }
              ),
              e.length > 0 && {
                handles: e.map(function (t) {
                  return { product_handle: t };
                }),
              }
            ),
            "Guest" === wlCustomerStatus
              ? { uuid: wlHulkUserUUID }
              : { customer_id: wlCustomerID }
          ),
          s =
            wlBaseUrl +
            ("Guest" === wlCustomerStatus
              ? "/wishlist/collection_product/status/guest"
              : "/wishlist/collection_product/status"),
          o = "Guest" !== wlCustomerStatus ? hulkShopDomain : null,
          n = "Guest" !== wlCustomerStatus ? wlCustomerID : null;
        HulkappWishlist._XMLHttpRequest("POST", s, i, o, n, function (t, e) {
          var i = JSON.parse(e);
          if (200 === t) {
            wlProductsData = i;
            var s =
              !0 === WishlistSettings.general.is_guest_enabled
                ? "Guest_Disabled"
                : wlCustomerStatus;
            a._updateCollectionBtnonStatusCheck(wishlistBtns, i, s);
          } else {
            var o = "Something went wrong. Please try again later !";
            i.message && (o = i.message), HulkappWishlist._messageUpdate(o);
          }
        });
      },
      _updateCollectionBtnonStatusCheck: function (t, e, i) {
        t.forEach(function (t) {
          var i = t.dataset.proid,
            s = e.find(function (t) {
              return parseInt(t.product_id) === parseInt(i);
            });
          if (!i) {
            var o = t.dataset.prohandle;
            (s = e.find(function (t) {
              return t.product_handle === o;
            })),
              (t.dataset.proid = s.product_id);
          }
          if (s) {
            var l = t.getElementsByClassName("hulkapps-wl-custom-icon")[0],
              n = t.querySelector(".hulkapps-wl-collection-count");
            if (
              (l &&
                (l.src = s.is_exist
                  ? collectionWishlistBtn.filled_set_custom_icon
                  : collectionWishlistBtn.empty_set_custom_icon),
              n)
            ) {
              var a = s.wishlist_count || 0,
                r = WishlistSettings.general.collection_compact_numbers
                  ? window.HulkappWishlist._compactNumbers(a)
                  : a;
              n.innerHTML = "top_count" === dataLayout ? r : "(".concat(r, ")");
            }
            t.setAttribute("data-added", s.is_exist);
            var u = WishlistSettings.general.is_exclude_enabled || !1,
              c = WishlistSettings.general.exclude_product_tags;
            if (s.product_tags && void 0 !== c) {
              var d = new Set(c),
                h = s.product_tags.some(function (t) {
                  return d.has(t);
                });
              u &&
                h &&
                setTimeout(function () {
                  t.classList.add("hide-hulk-product-wishlist"),
                    (t.style.display = null);
                }, 200);
            }
          }
        });
      },
    };
    // Expose the init function to the global scope
    window.HulkappWishlist = window.HulkappWishlist || {};
    window.HulkappWishlist.initCollection = a.init.bind(a);
    (function () {
      // Store the original open method
      const originalOpen = XMLHttpRequest.prototype.open;

      // Override the open method to capture request details
      XMLHttpRequest.prototype.open = function (
        method,
        url,
        async,
        user,
        pass
      ) {
        this._method = method;
        this._url = url;
        return originalOpen.apply(this, arguments);
      };

      // Store the original send method
      const originalSend = XMLHttpRequest.prototype.send;

      // Override the send method to attach event listeners
      XMLHttpRequest.prototype.send = function (body) {
        // Check if the request matches the specific wishlist endpoint
        if (
          this._url.includes(
            "/apps/advanced-wishlist/api/wishlist/collection_product/status/guest"
          ) &&
          this._method.toUpperCase() === "POST"
        ) {
          // Attach a listener for when the request completes
          this.addEventListener("readystatechange", function () {
            if (this.readyState === XMLHttpRequest.DONE) {
              if (this.status >= 200 && this.status < 300) {
                // AJAX call was successful, execute custom code
                executeCustomWishlistCode();
              } else {
                // Handle error responses if necessary
                console.error(
                  "Wishlist AJAX call failed:",
                  this.status,
                  this.statusText
                );
              }
            }
          });
        }
        // Additional condition to intercept the `add/guest` endpoint
        if (
          this._url.includes(
            "/apps/advanced-wishlist/api/wishlist/collection_product/add/guest"
          ) &&
          this._method.toUpperCase() === "POST"
        ) {
          try {
            // Parse the body to access `product_handle` if the body is JSON
            const requestBody = JSON.parse(body);

            // Check and modify `product_handle` if it contains a query part
            if (
              requestBody.product_handle &&
              requestBody.product_handle.includes("?")
            ) {
              requestBody.product_handle =
                requestBody.product_handle.split("?")[0];

              // Convert back to JSON and update the body
              body = JSON.stringify(requestBody);
            }
          } catch (error) {
            console.error("Failed to parse or modify request body:", error);
          }
        }

        // Proceed with sending the request
        return originalSend.apply(this, arguments);
      };

      // Your custom function to execute after AJAX completion
      function executeCustomWishlistCode() {
        let hulk_uuid = getCookie("hulk_wishlist_UserUUID");
        console.log("dddee", hulk_uuid);
        if (hulk_uuid) {
          const setWishlistCount = (count) => {
            $(`.header__icon--wishlist .header-count[data-totalwishlistitems]`)
              .text(count)
              .toggleClass("hidden", count === 0);
          };

          const hulk_api = `https://snowlife.ch/apps/advanced-wishlist/api/wishlist/count/guest?uuid=${hulk_uuid}&shop=${Shopify.shop}`;

          fetch(hulk_api)
            .then((res) => res.json())
            .then((data) => setWishlistCount(data.wishlist_count))
            .catch((error) =>
              console.error("Error fetching wishlist count:", error)
            );
        } else {
          $(
            `.header__icon--wishlist .header-count[data-totalwishlistitems]`
          ).addClass("hidden");
        }
      }
      // console.log('ddd');
      // window.onload = function() {
      //     executeCustomWishlistCode();
      // };
    })();
  },
});

// Function to preload a single image
function aicoPreloadImage(url) {
  const img = new Image();
  img.src = url;
  // Optionally, handle load and error events
  img.onload = () => {
    // console.log(`Image preloaded: ${url}`);
  };
  img.onerror = () => {
    console.error(`Failed to preload image: ${url}`);
  };
}

// Function to preload all images from elements with the specified class
function aicoPreloadFilterImages() {
  // Select all <a> elements with class 'aico-color-variant'
  const variantLinks = document.querySelectorAll("a.aico-color-variant");

  variantLinks.forEach((link) => {
    // Get the 'aico_var_img' attribute value
    const imgUrl = link.getAttribute("aico_var_img") + "&width=720";

    if (imgUrl) {
      aicoPreloadImage(imgUrl);
    }
  });
}

(function () {
  // Store the original open method
  const originalOpen = XMLHttpRequest.prototype.open;

  // Override the open method to capture request details
  XMLHttpRequest.prototype.open = function (method, url, async, user, pass) {
    this._method = method;
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  // Store the original send method
  const originalSend = XMLHttpRequest.prototype.send;

  // Override the send method to attach event listeners
  XMLHttpRequest.prototype.send = function (body) {
    // Handle the `/add` endpoint
    if (
      this._url.includes(
        "/apps/advanced-wishlist/api/wishlist/collection_product/add"
      ) &&
      this._method.toUpperCase() === "POST"
    ) {
      try {
        // Parse and modify the request body if necessary
        const requestBody = JSON.parse(body);
        // Example: Remove query params from `product_handle`
        if (
          requestBody.product_handle &&
          requestBody.product_handle.includes("?")
        ) {
          requestBody.product_handle = requestBody.product_handle.split("?")[0];
          // Convert back to JSON and update the body
          body = JSON.stringify(requestBody);
        }

        console.log("Modified request body for /add endpoint:", requestBody);
      } catch (error) {
        console.error("Failed to parse or modify request body:", error);
      }

      // Attach a listener for the response
      this.addEventListener("readystatechange", function () {
        if (this.readyState === XMLHttpRequest.DONE) {
          if (this.status >= 200 && this.status < 300) {
            executeCustomWishlistCodeCustomer();
          } else {
            console.error(
              "Error response from /add endpoint:",
              this.status,
              this.statusText
            );
          }
        }
      });
    }

    // Handle the `/status` endpoint
    if (
      this._url.includes(
        "/apps/advanced-wishlist/api/wishlist/collection_product/status"
      )
    ) {
      // Attach a listener for the response
      this.addEventListener("readystatechange", function () {
        if (this.readyState === XMLHttpRequest.DONE) {
          if (this.status >= 200 && this.status < 300) {
            executeCustomWishlistCodeCustomer();
          } else {
            console.error(
              "Error response from /status endpoint:",
              this.status,
              this.statusText
            );
          }
        }
      });
    }
    return originalSend.apply(this, arguments);
  };

  // Custom function to execute after successful requests
  function executeCustomWishlistCodeCustomer() {
    if (aico.login_customer_id != "undefined" && aico.login_customer_id != "") {
      const setWishlistCount = (count) => {
        $(`.header__icon--wishlist .header-count[data-totalwishlistitems]`)
          .text(count)
          .toggleClass("hidden", count === 0);
      };
      const hulk_api = `https://snowlife.ch/apps/advanced-wishlist/api/wishlist/count?customer_id=${aico.login_customer_id}&shop=${Shopify.shop}`;
      fetch(hulk_api)
        .then((res) => res.json())
        .then((data) => setWishlistCount(data.wishlist_count))
        .catch((error) =>
          console.error("Error fetching wishlist count:", error)
        );
    } else {
      $(
        `.header__icon--wishlist .header-count[data-totalwishlistitems]`
      ).addClass("hidden");
    }
  }
})();
